define('bindingHandlers/scrollTop',[
    'jquery',
    'lib/knockout'
],function(
    $,
    ko
    ){
    "use strict";

    /**
     * ScrollTop binding handler wraps scrollTop jquery function so the scroll top for a scrolling element
     * can be set based on a bound observable.
     *
     * This is useful when resetting results in a list - for example - when the list contents change or the next
     * page in the list is requested.
     *
     * @usage: <div data-bind="scrollTop:myScrollValue"><p>This is a div with a lot of text... it scrolls</p></div>
     *
     * Setting myScrollValue to 0 will reset the scroll to the top of the page.  Setting it to Number.POSITIVE_INFINITY
     * will scroll the text to the bottom of the scroll list.  Setting the value to anywhere within the scrollable
     * size of the element will set the scroll location to that value.
     *
     * @type {{update: update}}
     */
    ko.bindingHandlers.scrollTop = {
        init: function(element, valueAccessor){
            var observable = valueAccessor();
            observable.extend({ notify: 'always' });
        },

        update: function(element, valueAccessor){
            var currentScrollTop = +ko.unwrap(valueAccessor());
            if(!isNaN(currentScrollTop)){
                $(element).scrollTop(currentScrollTop);
            }
        }
    };
});
